import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { FiComponentsContainer } from '@fi-shared/fi-components-container';
import { FiColumnsContainerBaseDirective } from '@fi-shared/fi-two-columns-container/fi-columns-container-base.directive';

@Component({
    selector: 'fi-two-columns-container',
    template: `
        <div
            class="columns-container"
            #columnsContainer
            cdkScrollable
            (fiWhenScrolled)="scrolledToBottom()"
            [fiWhenScrolledListDisplayedItems]="listDisplayedItems"
        >
            <div class="side-container left-side" #leftSideContainer>
                <ng-content select="left-aligned-content"></ng-content>
            </div>
            <div class="side-container right-side" #rightSideContainer>
                <ng-content select="right-aligned-content"></ng-content>
            </div>
        </div>
    `,
    styleUrls: ['./fi-two-columns-container.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-two-columns-container' },
    providers: [{ provide: FiComponentsContainer, useExisting: FiTwoColumnsContainerComponent }],
    standalone: false,
})
export class FiTwoColumnsContainerComponent extends FiColumnsContainerBaseDirective {
    @Input() listDisplayedItems: number;
    @Output() whenScrolled = new EventEmitter<void>();

    protected scrolledToBottom() {
        this.whenScrolled.emit();
    }
}
